import { useMutation, useQueryClient } from "@tanstack/react-query"

import { USER_QUERY_KEY } from "@/constants/query"
import { createUser, deleteUsers, updateUser, changePasswordUser } from "@/http/user"

import { useMessage } from "@/hook/useMessage"

export const useUserMutation = () => {
  const client = useQueryClient()
  const { Success, Error, Process } = useMessage(USER_QUERY_KEY)

  const onSuccess = () => {
    client.invalidateQueries([USER_QUERY_KEY]).then()
    Success()
  }

  const onMutate = () => {
    Process()
  }

  const onError = (e: any) => {
    Error(e)
  }

  const createMutation = useMutation({
    mutationFn: createUser,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const updateMutation = useMutation({
    mutationFn: updateUser,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const deleteMutation = useMutation({
    mutationFn: deleteUsers,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const changePasswordMutation = useMutation({
    mutationFn: changePasswordUser,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  return {
    createMutation,
    updateMutation,
    deleteMutation,
    changePasswordMutation
  }
}
